import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import WelcomePage from './pages/WelcomePage/WelcomePage';
import BonusHistoryPage from './pages/BonusHistoryPage/BonusHistoryPage'; // Страница истории бонусов
import PurchaseHistoryPage from './pages/PurchaseHistoryPage/PurchaseHistoryPage'; // Страница истории покупок

const App = () => {
    return (
        <Router>
            <Routes>
                <Route path="/welcome/:sellerId/:clientId" element={<WelcomePage />} />
                <Route path="/bonusHistory/:sellerId/:clientId" element={<BonusHistoryPage />} />
                <Route path="/purchaseHistory/:sellerId/:clientId" element={<PurchaseHistoryPage />} />
            </Routes>
        </Router>
    );
};

export default App;
